import { render, staticRenderFns } from "./CGVPreConsultForm.vue?vue&type=template&id=5c85e3f5&scoped=true"
import script from "./CGVPreConsultForm.vue?vue&type=script&lang=js"
export * from "./CGVPreConsultForm.vue?vue&type=script&lang=js"
import style0 from "./CGVPreConsultForm.vue?vue&type=style&index=0&id=5c85e3f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85e3f5",
  null
  
)

export default component.exports